import React, {ChangeEvent} from 'react';
import {KeyboardTypeOptions, TextInput} from 'react-native';
import {Box} from '../box/index';
import {theme} from '../theme/theme';
import {Typography} from '../typography';

interface TextFieldProps {
  label: string;
  placeholder?: string;
  onChangeText: (e: string | ChangeEvent<any>) => void;
  onBlur: (e: any) => void;
  value?: string;
  error?: string;
  maxLength?: number;
  keyboardType?: KeyboardTypeOptions;
}

export const TextField: React.FC<TextFieldProps> = ({
  label,
  placeholder,
  onChangeText,
  onBlur,
  value,
  error,
  maxLength,
  keyboardType = 'default',
}: TextFieldProps) => {
  return (
    <Box>
      <Box pb="s">
        <Typography textStyle="s" color="textDefault">
          {label}
        </Typography>
      </Box>
      {/* @ts-expect-error react-native fix */}
      <TextInput
        maxLength={maxLength}
        keyboardType={keyboardType}
        onChangeText={onChangeText}
        onBlur={onBlur}
        value={value}
        placeholder={placeholder}
        placeholderTextColor={theme.colors.textLow}
        style={
          {
            fontFamily: theme.fonts.abc,
            padding: theme.space.two,
            color: theme.colors.textDefault,
            borderColor: theme.colors.outlines,
            borderWidth: theme.borderWidths.one,
            borderStyle: theme.borderStyles.solid,
          } as any
        }
      />
      <Box pt="s" minHeight="24px">
        <Typography textStyle="s" color="errorPrimary">
          {error}
        </Typography>
      </Box>
    </Box>
  );
};
